import React from 'react';
import Utils from 'screens/shared/utilities';
import {
  _t, getLanColor, createLink, computeTotalHDDandSSD,
} from 'utils';
import Section from 'screens/shared/section';
import Icon from 'screens/shared/icon';
import { RESOURCE_STATE, RESOURCE_TYPE, ROUTE } from 'constant';
import useFilter from './hooks/filters';

export default ({ servers = [], history = {}, dcId = '' }) => {
  const [filteredServers, FilterComponent] = useFilter({ servers });

  const onServerClick = (server) => {
    history.push(createLink(ROUTE.DASHBOARD.SERVER, { dcId, id: server?.id }));
  };

  const GetStorages = ({ volumes }) => {
    const { ssd, hdd } = computeTotalHDDandSSD(volumes);
    return (
      <div>
        <Utils.IconLabel icon="hdd" color="black" />
        <span>{`${ssd.length} SSDs ${ssd.length ? `(${ssd.reduce((a, b) => a + b, 0)} GB)` : ''} / `}</span>
        <span className="">{`${hdd.length} HDDs ${hdd.length ? `(${hdd.reduce((a, b) => a + b, 0)} GB)` : ''}`}</span>
      </div>
    );
  };

  return (
    <Section
      sectionTitle={_t('Servers')}
      onCreateClick={() => history.push(createLink(ROUTE.DASHBOARD.CREATE_SERVER, { dcId }))}
      isEmptyState={!servers.length}
      filterRender={FilterComponent}
      itemIcon={RESOURCE_TYPE.SERVER}
      setItemIconText={() => _t('Server')}
      itemIconAlign="top"
      items={filteredServers}
      setItemTitle={(e) => e?.properties?.name}
      itemOnClick={(e) => onServerClick(e)}
      setItemLoading={(e) => e?.metadata?.state === RESOURCE_STATE.BUSY}
      setItemDetails={(e) => (
        <div className="flex flex-direction-column">
          <Utils.Status state={e?.properties?.vmState} />
          <div className="flex flex-wrap">
            <Utils.IconLabel icon="memory" label={`${e?.properties?.ram / 1024} GB`} color="black" isCapitalize={false} />
            <Utils.IconLabel icon="microchip" className="m-l-20 m-r-20" label={`${e?.properties?.cores} Cores`} color="black" isCapitalize={false} />
            <GetStorages volumes={e?.entities?.volumes?.items} />
          </div>
          <div>
            {e?.entities?.nics?.items?.map?.((x) => (
              <span key={x?.properties?.lan} style={{ backgroundColor: getLanColor(x?.properties?.lan) }} className="lan">{x?.properties?.lan}</span>
            ))}
          </div>
        </div>
      )}
      tableColumns={['', 'Name', 'Status', 'RAM', 'Cores', 'Storage']}
      setTableRows={({ id, properties, entities }) => [
        <Icon name="server" />, { value: properties?.name, link: { id } }, <Utils.Status state={properties?.vmState} />,
        `${properties?.ram / 1024} GB`, properties?.cores, <GetStorages volumes={entities?.volumes?.items} />,
      ]}
    />
  );
};
